export interface BackgroundJobsFlags {
  geracaoFolhasMensais: boolean;
  emailsPrazoRelatorioAtividades: boolean;
  fecharProcessosSeletivosExpirados: boolean;
  limpezaNotificacoesAntigas: boolean;
}

export const DEFAULT_BACKGROUND_JOBS_FLAGS: BackgroundJobsFlags = {
  geracaoFolhasMensais: true,
  emailsPrazoRelatorioAtividades: true,
  fecharProcessosSeletivosExpirados: true,
  limpezaNotificacoesAntigas: true,
};

export function parseBackgroundJobsFlags(valor: string | undefined): BackgroundJobsFlags {
  if (!valor?.trim()) {
    return { ...DEFAULT_BACKGROUND_JOBS_FLAGS };
  }
  try {
    const parsed = JSON.parse(valor) as Record<string, unknown>;
    return {
      geracaoFolhasMensais:
        typeof parsed.geracaoFolhasMensais === 'boolean'
          ? parsed.geracaoFolhasMensais
          : DEFAULT_BACKGROUND_JOBS_FLAGS.geracaoFolhasMensais,
      emailsPrazoRelatorioAtividades:
        typeof parsed.emailsPrazoRelatorioAtividades === 'boolean'
          ? parsed.emailsPrazoRelatorioAtividades
          : DEFAULT_BACKGROUND_JOBS_FLAGS.emailsPrazoRelatorioAtividades,
      fecharProcessosSeletivosExpirados:
        typeof parsed.fecharProcessosSeletivosExpirados === 'boolean'
          ? parsed.fecharProcessosSeletivosExpirados
          : DEFAULT_BACKGROUND_JOBS_FLAGS.fecharProcessosSeletivosExpirados,
      limpezaNotificacoesAntigas:
        typeof parsed.limpezaNotificacoesAntigas === 'boolean'
          ? parsed.limpezaNotificacoesAntigas
          : DEFAULT_BACKGROUND_JOBS_FLAGS.limpezaNotificacoesAntigas,
    };
  } catch {
    return { ...DEFAULT_BACKGROUND_JOBS_FLAGS };
  }
}

export function serializeBackgroundJobsFlags(flags: BackgroundJobsFlags): string {
  return JSON.stringify({
    geracaoFolhasMensais: flags.geracaoFolhasMensais,
    emailsPrazoRelatorioAtividades: flags.emailsPrazoRelatorioAtividades,
    fecharProcessosSeletivosExpirados: flags.fecharProcessosSeletivosExpirados,
    limpezaNotificacoesAntigas: flags.limpezaNotificacoesAntigas,
  });
}
